import { AsyncPipe, NgClass } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule, provideConfig } from '@spartacus/core';
import { GenericLinkModule } from '@spartacus/storefront';

import { DpFooterNavigationComponent } from './footer-navigation.component';

import { DpFooterNavigationUiComponent } from './footer-navigation-ui/footer-navigation-ui.component';

@NgModule({
  imports: [I18nModule, GenericLinkModule, NgClass, AsyncPipe],
  providers: [
    provideConfig({
      cmsComponents: {
        FooterNavigationComponent: {
          component: DpFooterNavigationComponent,
        },

        NavigationUIComponent: {
          component: DpFooterNavigationUiComponent,
        },
      },
    }),
  ],
  declarations: [DpFooterNavigationComponent, DpFooterNavigationUiComponent],
  exports: [DpFooterNavigationComponent, DpFooterNavigationUiComponent],
})
export class DpFooterNavigationModule {}
